import { Locale } from '@headless-workspace/config';
import { StringHelpers } from '@headless-workspace/utils';
import { PromotionType } from '../../../../../server';

type GetPriorPriceParams = {
    promotion?: PromotionType;
    originalPrice: number;
    priorPrice: number;
};

export const getPriorPrice = ({ promotion, originalPrice, priorPrice }: GetPriorPriceParams) => {
    return promotion === PromotionType.STANDARD ? originalPrice : priorPrice;
};

type GetPriorPriceLabelProps = GetPriorPriceParams & {
    originalPriceText: string;
    lowerPriceText: string | undefined;
    locale: Locale;
    currency: string;
};

export const getPriorPriceLabel = ({
    promotion,
    originalPrice,
    priorPrice,
    originalPriceText,
    lowerPriceText,
    locale,
    currency,
}: GetPriorPriceLabelProps): string => {
    const price = getPriorPrice({ promotion, originalPrice, priorPrice });
    const priceText = promotion === PromotionType.STANDARD ? originalPriceText : lowerPriceText;

    if (price === 0) {
        return '';
    }
    return `${priceText} ${StringHelpers.formatPrice({ price, currency, locale })}`;
};
